import { runClientComponent } from '../../_common/client/client-component-runner';
import { CustomerReviewImageGalleryComponent } from './customer-review-image-gallery.component';

import '../../_feature-components/zoom-image';

runClientComponent({ customerReviewImageGallery: CustomerReviewImageGalleryComponent });
